import { MapPin, Phone, Mail, Clock, ExternalLink } from "lucide-react";

const Contact = () => {
  return (
    <section id="contact" className="py-24 bg-slate-50">
      <div className="container mx-auto px-4">
        <div className="text-center max-w-3xl mx-auto mb-16">
          <div className="inline-block bg-emerald-50 rounded-full px-6 py-2 mb-6">
            <span className="text-emerald-700 font-semibold text-sm tracking-wide">CONTACT US</span>
          </div>
          
          <h2 className="text-4xl md:text-5xl font-bold text-slate-900 mb-6">
            Visit Our Office
          </h2>
          
          <p className="text-lg text-slate-600">
            We're conveniently located in Banashankari, Bengaluru. Visit us or get in touch for expert consultation.
          </p>
        </div>

        <div className="grid lg:grid-cols-2 gap-12 items-start">
          {/* Contact Information */}
          <div className="space-y-6">
            <div className="bg-white rounded-xl p-8 shadow-md border border-slate-100">
              <div className="flex items-start gap-4">
                <div className="bg-emerald-100 rounded-lg p-3 flex-shrink-0">
                  <MapPin className="text-emerald-700" size={24} />
                </div>
                <div>
                  <h3 className="font-bold text-slate-900 mb-2">Office Address</h3>
                  <p className="text-slate-600 leading-relaxed">
                    Chaitra Enterprises<br />
                    515, 1st Cross Rd<br />
                    Umarbagh Layout, Banashankari Temple Ward<br />
                    Bengaluru, Karnataka 560070
                  </p>
                  <a 
                    href="https://maps.app.goo.gl/gsQjpuMqAbFiMkiFA?g_st=aw"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-flex items-center gap-2 text-emerald-600 hover:text-emerald-700 font-semibold mt-3 transition-colors"
                  >
                    Get Directions
                    <ExternalLink size={16} />
                  </a>
                </div>
              </div>
            </div>

            <div className="bg-white rounded-xl p-8 shadow-md border border-slate-100">
              <div className="flex items-start gap-4">
                <div className="bg-blue-100 rounded-lg p-3 flex-shrink-0">
                  <Phone className="text-blue-700" size={24} />
                </div>
                <div>
                  <h3 className="font-bold text-slate-900 mb-2">Phone Numbers</h3>
                  <div className="space-y-2">
                    <a 
                      href="tel:+918217026707"
                      className="block text-slate-600 hover:text-emerald-600 transition-colors"
                    >
                      +91 82170 26707
                    </a>
                    <a 
                      href="tel:+917411026699"
                      className="block text-slate-600 hover:text-emerald-600 transition-colors"
                    >
                      +91 74110 26699
                    </a>
                  </div>
                </div>
              </div>
            </div>

            <div className="bg-white rounded-xl p-8 shadow-md border border-slate-100">
              <div className="flex items-start gap-4">
                <div className="bg-purple-100 rounded-lg p-3 flex-shrink-0">
                  <Mail className="text-purple-700" size={24} />
                </div>
                <div>
                  <h3 className="font-bold text-slate-900 mb-2">Email Address</h3>
                  <a 
                    href="mailto:chaitraenterprisesbsk@gmail.com"
                    className="text-slate-600 hover:text-emerald-600 transition-colors break-all"
                  >
                    chaitraenterprisesbsk@gmail.com
                  </a>
                </div>
              </div>
            </div>

            <div className="bg-white rounded-xl p-8 shadow-md border border-slate-100">
              <div className="flex items-start gap-4">
                <div className="bg-amber-100 rounded-lg p-3 flex-shrink-0">
                  <Clock className="text-amber-700" size={24} />
                </div>
                <div>
                  <h3 className="font-bold text-slate-900 mb-2">Business Hours</h3>
                  <div className="space-y-1 text-slate-600">
                    <p>Monday - Saturday: 10:00 AM - 6:00 PM</p>
                    <p>Sunday: Closed</p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Map */}
          <div className="bg-white rounded-xl shadow-md overflow-hidden border border-slate-100 h-full min-h-[600px]">
            <iframe 
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3888.8476!2d77.5611!3d12.9183!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zMTLCsDU1JzA1LjkiTiA3N8KwMzMnNDAuMCJF!5e0!3m2!1sen!2sin!4v1234567890"
              width="100%"
              height="100%"
              style={{ border: 0, minHeight: '600px' }}
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              title="Chaitra Enterprises Location"
            ></iframe>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;
